import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import {CustomModule} from "../customs/custom.module";
import {ChooseDoctorListModalRoutingModule} from "./choose-doctor-list-modal-routing.module";
import {ChooseDoctorListModalComponent} from "./choose-doctor-list-modal.component";
import { DoctorProfileTypeModalPageModule } from '../doctor-profile-type-modal/doctor-profile-type-modal.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,    
    ChooseDoctorListModalRoutingModule,
      CustomModule,
      DoctorProfileTypeModalPageModule
  ],
  declarations: [ChooseDoctorListModalComponent]
})
export class ChooseDoctorListModalModule {}
